import { writable } from "svelte/store";
/* when hero is true, it removes header spacer and makes nav transparent */
export default writable({ hero: false });
